import axios from '../api';

export async function getSetting(id) {
  const { data } = await axios.get('/settings/' + id);
  return data;
}
